import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { commonMessages as appointmentMessages } from '@/messages/appointment';
export type AppointmentReasonValue =
  | 'discover_and_try'
  | 'discover_and_try_gallet'
  | 'discover_and_try_multibrand'
  | 'purchase'
  | 'purchase_gallet'
  | 'find_a_new_strap'
  | 'find_a_new_strap_gallet'
  | 'boutique_pick_up'
  | 'take_care_of_my_breitling'
  | 'other';

export const defaultAppointmentReason: AppointmentReasonValue =
  'discover_and_try';

export function useAppointmentReasonOptions() {
  const { formatMessage } = useIntl();
  const options = useMemo(
    () => [
      {
        label: formatMessage(appointmentMessages.discover_and_try),
        value: 'discover_and_try',
      },
      {
        label: formatMessage(appointmentMessages.discover_and_try_gallet),
        value: 'discover_and_try_gallet',
      },
      {
        label: formatMessage(appointmentMessages.discover_and_try_multibrand),
        value: 'discover_and_try_multibrand',
      },
      { label: formatMessage(appointmentMessages.purchase), value: 'purchase' },
      {
        label: formatMessage(appointmentMessages.purchase_gallet),
        value: 'purchase_gallet',
      },
      {
        label: formatMessage(appointmentMessages.find_a_new_strap),
        value: 'find_a_new_strap',
      },
      {
        label: formatMessage(appointmentMessages.find_a_new_strap_gallet),
        value: 'find_a_new_strap_gallet',
      },
      {
        label: formatMessage(appointmentMessages.pickUp),
        value: 'boutique_pick_up',
      },
      {
        label: formatMessage(appointmentMessages.take_care_of_my_breitling),
        value: 'take_care_of_my_breitling',
      },
      { label: formatMessage(appointmentMessages.other), value: 'other' },
    ],
    [formatMessage],
  );

  const defaultOption = options.find(
    (o) => o.value === defaultAppointmentReason,
  )!;
  return { options, defaultOption };
}
